import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { apisDataCacheKeys, Oms_package_id } from '@app-constants/app.constants';
import { getCourseId } from '@app-helpers/functions';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-add-to-cart',
  templateUrl: './add-to-cart.component.html',
  styleUrls: ['./add-to-cart.component.scss']
})
export class AddToCartComponent implements OnInit {

  constructor(public router: Router, public dialogRef: MatDialogRef<AddToCartComponent>, @Inject(MAT_DIALOG_DATA) public pack_data: any,
    public SubscriptionService: SubscriptionService, public spinner: NgxSpinnerService, 
    private gaService: GAnalyticsService, private datePipe: DatePipe
  ) { }
public show_view_button:boolean = true;
public viewCart_flag :boolean = false;
  ngOnInit(): void { 
    console.log(this.pack_data);
    if(this.pack_data?.productId == 7){
      this.onloadfunction();
    }else{
      this.show_view_button = false;
    }
  }
  onloadfunction(){
    if(this.pack_data?.examName){
      let userDetails =  JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))
        let payloadData1 = {
          "grade":[Number(userDetails?.grade?.name.replace('th',''))],
          "exam_type":[getCourseId(this.pack_data?.examName||localStorage.getItem('targetExamName'))],
          "test_type":['fc180abf-a9cb-4bea-b30e-28d8442ae3b8'],
          "phone":userDetails?.phone
        };
        this.SubscriptionService.getTimeSlots(payloadData1).subscribe((response:any)=>{
          let cartDetails_scoredID = [... new Set(this.SubscriptionService.scoreSelectionDetails.allCartItems?.filter(v=>v.scoreId && v?.exams?.toLowerCase().indexOf(payloadData1?.exam_type[0]?.toString().toLowerCase()) != -1)?.map(v=>v.scoreId)?.filter(v=>v))]
          this.show_view_button =  !response?.map(v=>v._id).reduce((a,v,i,s)=>{
            a.push(cartDetails_scoredID.findIndex(inv=>inv==v))
            return a
        },[]).every(v=>v==-1)
        if(response?.length == cartDetails_scoredID?.length){// if added score is equal to timeslots
          this.show_view_button = false;
        }
        })
    }else{
      this.show_view_button = false;
    }
    this.viewCart_flag= [3,1,6,8,Oms_package_id.bookspackage].some(v=>this.pack_data?.productId)

  }
  routeToMycart(pack_data?) {
    this.dialogRef.close()
    if (pack_data?.type == 'from-wishlist') {
      this.router.navigate(['/subscription/wishlist']);
    } else {
      this.router.navigate(['/subscription/mycart']);
    }
  }
  addTocart() {
    this.spinner.show();
    console.log(this.pack_data);
    this.gaService.webEngageEvent({
      'event': 'Added To Cart',
      'package_name': this.pack_data?.name,
      'date': this.datePipe.transform( this.pack_data?.validDate, 'dd MMM yyyy')
    });
    if (this.pack_data?.productId == 7) {
      this.router.navigate(['/subscription/proceed-to-payment'], { state: { ...this.pack_data, productName: 'score' } })
      this.spinner.hide()
      this.dialogRef.close()
    } else {
      var userDetails = localStorage.getItem('user_details_from_server') ? JSON.parse(localStorage.getItem('user_details_from_server')) : {}
      let body = {
        "batchId": '',
        "courseId": '',
        "created_by": userDetails?.firstName + ' ' + userDetails?.lastName,
        "created_date": moment().utc(),
        "grade": userDetails?.grade?.name?.replace(/[^0-9]/g, ''),
        "id": 0,
        "modified_by": userDetails?.firstName + ' ' + userDetails?.lastName,
        "modified_date": moment().utc(),
        "phoneNo": userDetails?.phone,
        "priority": 1,
        "quantity": 1,
        "status": true,
        "subscriptionId": this.pack_data?.id,
        "userId": userDetails?.userId
      }

      this.SubscriptionService.addInWishlist(body).subscribe((response) => {
        this.spinner.hide()
        this.routeToMycart()
      })
    }

  }
}
